export default __webpack_public_path__ + "static/media/Timeline-GiftBoxes-21.b89cbb10.png";